import React, { PropsWithChildren, useEffect, useState } from 'react';
import { Box } from '@mui/material';
import Skeleton from '@/components/@IntranetLibrary/Skeleton';
import { imgUrlChk } from '@/utils/function';
import Image from 'next/image';

export type MyPageProfileProps = PropsWithChildren<{
  profileImageUrl: string;
}>;

export const defaultImageUrl = '/images/dummy/default-profile.svg';

const MyPageProfile = ({ profileImageUrl, children }: MyPageProfileProps) => {
  const [isImageLoading, setIsImageLoading] = useState(true);
  const [imgSrc, setImageSrc] = useState('');

  useEffect(() => {
    setImageSrc(imgUrlChk(`${profileImageUrl}`));
  }, [profileImageUrl]);

  return (
    <Box
      sx={{
        padding: '24px 0',
        backgroundColor: 'black',
        position: 'relative',
        background: `#000 url('/images/mypage/grapch.png') center / cover no-repeat`,
        '.profile-image': {
          display: 'block',
          margin: 'auto',
          borderRadius: '12px',
          objectFit: 'cover',
        },
      }}
    >
      {isImageLoading && (
        <Skeleton
          variant="rect"
          width={180}
          height={180}
          sx={{
            position: 'absolute',
            top: '24px',
            left: '50%',
            transform: 'translateX(-50%)',
          }}
        />
      )}
      <Image
        src={imgSrc}
        width={180}
        height={180}
        alt={'profile-image'}
        className={'profile-image'}
        onError={() => {
          setIsImageLoading(false);
          setImageSrc(defaultImageUrl);
        }}
        onLoadingComplete={() => {
          setIsImageLoading(false);
        }}
      />
      {children}
    </Box>
  );
};

export default MyPageProfile;
